__turbopack_context__.v({
  "placeholder": "w0HF2q_placeholder",
  "tooltip-link": "w0HF2q_tooltip-link",
});
